import { defineStore } from 'pinia';
import { setAIChecked, getAIChecked, deleteAIChecked } from '@/utils/storage/setting';

interface DeviceState {
  isConnect: boolean;
  connectLoading: boolean;
  deviceList: any;
  currentDevice: any;
  // 行为检测设置
  aiChecked: boolean;
  platform:string
}
export const useDeviceStore = defineStore({
  id: 'app-device',
  state: (): DeviceState => ({
    isConnect: false,
    connectLoading: false,
    deviceList: [],
    currentDevice: [],
    platform:'',
    aiChecked: getAIChecked() == null ? false : getAIChecked(),
  }),
  getters: {
    _getAIChecked() {
      return this.aiChecked;
    },
    _getPlatform() {
      return this.aiChecked;
    },
  },
  actions: {
    _changeAiChecked(value: boolean) {
      this.aiChecked = value;
      setAIChecked(value);
    },
    changeConnect(value: boolean) {
      this.isConnect = value;
    },
    changeConnectLoading(value: boolean) {
      this.connectLoading = value;
    },
    changeDeviceList(list: any) {
      this.deviceList = list;
    },
    changeCurrentDevice(list: any) {
      this.currentDevice = list;
    },
    changePlatform(data: any) {
      console.log("🚀 ~ changePlatform ~ data:", data)
      this.platform = data;
    },
    researchDevice() {
      this.isConnect = false;
      this.deviceList = [];
      this.currentDevice = [];
    },
  },
});
